<ng-template #messageInfo let-model>
  <!-- Modal content -->
  <div class="modal-header" [ngStyle]="{
        'justify-content': 'right',
        height: '40px',
        backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
        'border-bottom':
          (Merchant$ | async)?.webapp_settings?.menu_border_width +
          'px solid ' +
          (Merchant$ | async)?.webapp_settings?.menu_border_color,
      }">
    <a (click)="model.close()" id="btnnotification" class="close-icon">
      <i [ngStyle]="{
                color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
              }" class="zmdi zmdi-close zmdi-hc-fw"></i>
    </a>
  </div>
  <div class="modal-body">
    <p [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings?.menu_font_color_allpage,
          }" id="textcontent" [innerHTML]="textMessage"></p>
  </div>
  <div class="modal-footer" [ngStyle]="{ display: 'block' }">
    <div class="d-grid">
      <button class="btn btn-accent-theme btn-lg mt-2" [ngStyle]="{
                color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
                backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                border:
                  (Merchant$ | async)?.webapp_settings?.menu_border_width +
                  'px solid ' +
                  (Merchant$ | async)?.webapp_settings?.menu_border_color,
              }" (click)="model.close()">
        OK
      </button>
    </div>
  </div>
</ng-template>
